import React, {useState} from 'react';
import { Table, Form } from 'react-bootstrap';

import { toast } from 'react-toastify' //npm i react-toastify
import getDataFromApi from '../../api/getDataFromApi'
import loader from './../../../img/preLoader.gif'

export default function SystemUsersShow(props) {

    const {users, setResponseUsers} = props;
    const [loading, setLoading] = useState(false)

    return <div className='SystemUsersShow'>
        <h2>משתמשים קיימים במערכת</h2>
        <img src={loader} alt="loader" className={!loading ? 'loader' : 'loader active animate__animated animate__fadeIn'} />

        <div className='tableHospital'>
            <Table striped >
                <thead>
                    <tr>
                        <th>שם מלא</th>
                        <th>שם משתמש</th>
                        <th>סוג משתמש</th>
                        <th>סטטוס</th>
                        <th>פעולות</th>
                    </tr>
                </thead>

                {users[0]?.id ? <tbody>
                    {users.map((item) => 

                        <UserItem item ={item} key={item.id} loading = { loading } setLoading= {setLoading} setResponseUsers = { setResponseUsers } />

                    )}
                </tbody>  : <tbody>
                    <tr><td colSpan={5} className='noResults'>אין משתמשים</td></tr>
                </tbody> }
            </Table>
        </div>
        

  </div>;
}

function UserItem(props) {

    const {item, loading, setLoading, setResponseUsers} = props;

    const resetPassword = () => {

        if (window.confirm('האם אתה בטוח שברצונך לאפס את הסיסמה?')) {

            const send = {
                userId: item.id
            }

            resetPasswordApi('resetUserPassword','users', send , setLoading, setResponseUsers);
        }
    }

    const deleteUser = () => {

        if (window.confirm('האם אתה בטוח שברצונך למחוק את המשתמש? פעולה זו אינה ניתנת לביטול!')) {

            const send = {
                userId: item.id
            }

            deleteUserApi('deleteUser','users', send , setLoading, setResponseUsers);
        }
    }



    const getUserType = (userType) => {
        switch(userType) {
            case '1': return 'מנהל מערכת';
            case '2': return 'מנהל';
            case '3': return 'משתמש רגיל';
            case '4': return 'רק צפייה';
            default: return 'לא מוגדר';
        }
    }



    return <tr>
        <td>{item.name}</td>
        <td>{item.username}</td>
        <td>{getUserType(item.userType)}</td>
        <td>
            <span className={`status ${item.status === '1' ? 'active' : 'inactive'}`}>
                {item.status === '1' ? 'פעיל' : 'לא פעיל'}
            </span>
        </td>
        <td className='actions'>
            <button 
                className='btn btn-sm btn-outline-warning me-1' 
                onClick={resetPassword}
                disabled={loading}
                title="איפוס סיסמה"
            >
                🔐
            </button>
            <button 
                className='btn btn-sm btn-outline-danger' 
                onClick={deleteUser}
                disabled={loading}
                title="מחק משתמש"
            >
                🗑️
            </button>
        </td>
    </tr>
}

function resetPasswordApi(url, controller, objectToSend, setLoading, setResponseUsers) {
    setLoading(true)
    const getData = getDataFromApi(url, objectToSend, controller, 'all')

    getData.then((getData) => {

        if (getData.ok) {
            toast.success(getData.ok);
            setResponseUsers(false); // This will trigger a reload
        } else if (getData.error) {
            toast.error(getData.error)
        }
    })

    getData.catch((error) => {
        console.log(error)
        toast.error('שגיאה בתקשורת עם השרת')
    })

    getData.finally(() => {
        setLoading(false)
    })
}

function deleteUserApi(url, controller, objectToSend, setLoading, setResponseUsers) {
    setLoading(true)
    const getData = getDataFromApi(url, objectToSend, controller, 'all')

    getData.then((getData) => {

        if (getData.ok) {
            toast.success(getData.ok);
            setResponseUsers(false); // This will trigger a reload
        } else if (getData.error) {
            toast.error(getData.error)
        }
    })

    getData.catch((error) => {
        console.log(error)
        toast.error('שגיאה בתקשורת עם השרת')
    })

    getData.finally(() => {
        setLoading(false)
    })
}

